import { render, staticRenderFns } from "./DotChart.vue?vue&type=template&id=13d44e24&"
import script from "./DotChart.vue?vue&type=script&lang=js&"
export * from "./DotChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports